import { DATE_OPTIONS, getDateFromNow } from "../../../core/utils/date-utils";

/**
 * Rapor grid'inin açılış filtresi — sol panel (ReportFilter) ve hızlı filtre çubuğunun "Sıfırla"sı ortak kullanır.
 */
export const getDefaultReportDate = () => {
    const date = getDateFromNow(DATE_OPTIONS.LAST_15_DAYS);
    return [date.start, date.end]
}

export const buildDefaultReportFilter = () => {
    const date = getDefaultReportDate();

    return {
        reportDateBegin: date[0],
        reportDateEnd: date[1],
        isDeleted: false
    }
}
